import { breadcrumb, webPage } from './Seo';
import {
  SITE, ORGANIZATION, WEBSITE, PEOPLE_GRAPH, APPS_SCHEMA, FOUNDER, COFOUNDER,
} from './siteData';

const HOME_BC = ['Home', '/'];

/* ---------------------------------- HOME --------------------------------- */
export const HOME_SEO = {
  path: '/',
  title: 'VTCodex – Website & Mobile App Development Company India | Founders Vishal Rana & Tanisha Garg',
  description:
    'VTCodex (vtcodex.com) is a website development, Android app development & digital solutions company in India, founded by Vishal Rana and Tanisha Garg. React, Node.js, SEO, payment gateway, hosting. Live apps on Google Play.',
  keywords:
    'VTCodex, vtcodex.com, VTCodex founder, VTCodex co-founder, Vishal Rana VTCodex, Tanisha Garg VTCodex, Vishal Rana founder, Tanisha Garg co-founder, website development company India, mobile app development India, web design Haryana, React developer, Node.js developer, SEO services India, Play Store apps, school website, college website',
  schema: [
    ORGANIZATION,
    WEBSITE,
    PEOPLE_GRAPH,
    webPage('VTCodex – Website & App Development Company', '/', 'Home of VTCodex, founded by Vishal Rana and Tanisha Garg.', 'WebPage'),
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        ['Who is the founder of VTCodex?', 'Vishal Rana is the Founder of VTCodex. LinkedIn: https://www.linkedin.com/in/vishalrana227'],
        ['Who is the co-founder of VTCodex?', 'Tanisha Garg is the Co-Founder of VTCodex. LinkedIn: https://www.linkedin.com/in/tanisha-garg-70116b313'],
        ['What does VTCodex do?', 'VTCodex builds websites, Android apps, backends, payment gateway integrations and provides SEO, domain and hosting services for schools, colleges, institutes and businesses across India.'],
        ['Does VTCodex have apps on Google Play?', 'Yes. VTCodex has published apps such as VTCodeX Restro (restaurant billing) and Rasdhara (cattle feed ordering) on the Google Play Store.'],
        ['How can I contact VTCodex?', 'Call or WhatsApp +91 94991 30923, or email contact@vtcodex.com.'],
      ].map(([q, a]) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } })),
    },
  ],
};

/* -------------------------------- SERVICES ------------------------------- */
const SERVICE_LIST = [
  ['Website Development', 'Fast, responsive, SEO-ready websites built with React, Next.js and WordPress.'],
  ['Mobile App Development', 'Android apps built with React Native and Flutter, published on Google Play.'],
  ['Backend Development', 'Secure Node.js, Express and MongoDB APIs and admin panels.'],
  ['Payment Gateway Integration', 'Razorpay, UPI, cards and wallets integrated safely into your website or app.'],
  ['SEO Optimization', 'Technical SEO, on-page SEO and schema markup to rank higher on Google.'],
  ['Domain & Hosting', 'Domain registration, hosting setup, SSL and email configuration.'],
  ['Website Deployment', 'Production deployment, CI and performance tuning.'],
];
export const SERVICES_SEO = {
  path: '/services',
  title: 'Website, Mobile App, Backend & SEO Services in India | VTCodex',
  description:
    'Hire VTCodex for website development, Android app development, backend APIs, payment gateway integration, SEO, domain & hosting. Affordable, fast delivery by founders Vishal Rana & Tanisha Garg.',
  keywords:
    'website development services India, app development services, backend development, payment gateway integration, SEO services, domain and hosting, VTCodex services, web development company Haryana',
  schema: [
    breadcrumb([HOME_BC, ['Services', '/services']]),
    webPage('VTCodex Services', '/services', 'Web, app, backend and SEO services by VTCodex.', 'CollectionPage'),
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: SERVICE_LIST.map(([n, d], i) => ({
        '@type': 'ListItem', position: i + 1,
        item: { '@type': 'Service', name: n, description: d, provider: { '@id': 'https://vtcodex.com/#organization' }, areaServed: 'IN', serviceType: n },
      })),
    },
  ],
};

/* -------------------------------- PROJECTS ------------------------------- */
const PROJECT_LIST = [
  ['Best Recruitment Company Website', 'https://www.strivebusinesssolution.com/', 'Recruitment platform website built by VTCodex with React.js and Framer Motion.'],
  ['Education System – BIS Bhiwani', 'https://bisbhiwani.in/', 'School management and information system website built by VTCodex.'],
  ['InfoTech KS Business Website', 'https://infotechks.com/', 'Conversion-focused business website built by VTCodex.'],
  ['Trinity Global IT Education Institute', 'https://www.trinityglobalofficial.com/', 'IT education institute website built by VTCodex.'],
  ['Big Bang Shoppers', 'https://bigbangshoppers.com/', 'Shopping website built by VTCodex with React.js.'],
  ['Hotel The Heera Divine', 'https://hoteltheheeradivine.vercel.app/', 'Hotel website concept by VTCodex using Next.js and Tailwind.'],
  ['Myntra Ecommerce Website UI', 'https://e-commerce-website-tau-ten.vercel.app/', 'Ecommerce interface design by VTCodex.'],
  ['GoStay Hotel Booking', 'https://hotel-booking-website-blond.vercel.app/', 'Hotel booking website UI by VTCodex.'],
];
export const PROJECTS_SEO = {
  path: '/projects',
  title: 'Website Projects & Portfolio – Built by VTCodex (Vishal Rana & Tanisha Garg)',
  description:
    'Explore websites built by VTCodex: recruitment, education, business, ecommerce and hotel websites in React & Next.js. Every project designed and developed by VTCodex, India.',
  keywords:
    'VTCodex projects, VTCodex portfolio, websites built by VTCodex, React website projects, school website, recruitment website, ecommerce website, hotel booking website, web development portfolio India',
  schema: [
    breadcrumb([HOME_BC, ['Projects', '/projects']]),
    webPage('VTCodex Projects & Portfolio', '/projects', 'Websites designed and developed by VTCodex.', 'CollectionPage'),
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Websites built by VTCodex',
      itemListElement: PROJECT_LIST.map(([n, u, d], i) => ({
        '@type': 'ListItem', position: i + 1,
        item: {
          '@type': 'WebSite', name: n, url: u, description: d,
          creator: { '@id': 'https://vtcodex.com/#organization' },
          author: { '@id': 'https://vtcodex.com/#organization' },
        },
      })),
    },
  ],
};

/* ---------------------------------- APPS --------------------------------- */
export const APPS_SEO = {
  path: '/apps',
  title: 'Android Apps by VTCodex on Google Play – VTCodeX Restro & Rasdhara',
  description:
    'Download VTCodex apps from Google Play: VTCodeX Restro (restaurant billing) and Rasdhara (cattle feed ordering). Android apps built by VTCodex, founded by Vishal Rana & Tanisha Garg.',
  keywords:
    'VTCodex apps, VTCodex Play Store, VTCodeX Restro, restaurant billing app, Rasdhara app, cattle feed app, Android app development India, React Native apps, Firebase apps',
  schema: [
    breadcrumb([HOME_BC, ['Apps', '/apps']]),
    webPage('VTCodex Android Apps', '/apps', 'Android apps published by VTCodex on Google Play.', 'CollectionPage'),
    ...APPS_SCHEMA,
  ],
};

/* --------------------------------- COURSES ------------------------------- */
export const COURSES_SEO = {
  path: '/courses',
  title: 'Web Development & Programming Courses with Live Projects | VTCodex',
  description:
    'Learn Full Stack Development, React, Node.js and more with real projects at VTCodex. Practical, industry-focused training from the team behind live websites and Play Store apps.',
  keywords:
    'full stack development course, React course, Node.js course, web development training India, coding course Haryana, VTCodex courses, learn web development with projects',
  schema: [
    breadcrumb([HOME_BC, ['Courses', '/courses']]),
    webPage('VTCodex Courses', '/courses', 'Practical programming courses by VTCodex.', 'CollectionPage'),
    {
      '@context': 'https://schema.org',
      '@type': 'Course',
      name: 'Full Stack Development',
      description: 'Master frontend, backend and deployment: React, Next.js, Node.js, Express, MongoDB, REST APIs, JWT and cloud deployment with real projects.',
      provider: { '@type': 'Organization', name: 'VTCodex', sameAs: SITE.url },
    },
  ],
};

/* ---------------------------------- TEAM --------------------------------- */
export const TEAM_SEO = {
  path: '/team',
  title: 'Vishal Rana (Founder) & Tanisha Garg (Co-Founder) – VTCodex Team',
  description:
    'Meet Vishal Rana, Founder, and Tanisha Garg, Co-Founder of VTCodex. Connect on LinkedIn, call or WhatsApp the founders of VTCodex – website & mobile app development company in India.',
  keywords:
    'Vishal Rana VTCodex, Tanisha Garg VTCodex, VTCodex founder, VTCodex co-founder, founder of VTCodex, co-founder of VTCodex, Vishal Rana founder, Tanisha Garg co-founder, VTCodex team, VTCodex leadership, Vishal Rana LinkedIn, Tanisha Garg LinkedIn',
  schema: [
    breadcrumb([HOME_BC, ['Team', '/team']]),
    { ...webPage('Vishal Rana & Tanisha Garg – Founders of VTCodex', '/team', 'Leadership of VTCodex.', 'AboutPage'),
      mainEntity: [{ '@id': FOUNDER['@id'] }, { '@id': COFOUNDER['@id'] }] },
    PEOPLE_GRAPH,
    ORGANIZATION,
  ],
};

/* ------------------------------ TESTIMONIALS ----------------------------- */
export const TESTIMONIALS_SEO = {
  path: '/testimonials',
  title: 'Client Reviews & Testimonials | VTCodex',
  description:
    'Read what clients say about working with VTCodex for websites, apps, SEO and payment gateway integration.',
  keywords: 'VTCodex reviews, VTCodex testimonials, client feedback, web development reviews India',
  schema: [
    breadcrumb([HOME_BC, ['Reviews', '/testimonials']]),
    webPage('VTCodex Client Reviews', '/testimonials', 'Client feedback for VTCodex.'),
  ],
};

/* --------------------------------- CONTACT ------------------------------- */
export const CONTACT_SEO = {
  path: '/contact',
  title: 'Contact VTCodex – Call, WhatsApp or Email for Website & App Development',
  description:
    'Contact VTCodex for a free quote on website or mobile app development. Call/WhatsApp +91 94991 30923, email contact@vtcodex.com. Mon–Sat 9AM–8PM.',
  keywords:
    'contact VTCodex, VTCodex phone number, VTCodex WhatsApp, hire web developer India, website development quote, app development quote',
  schema: [
    breadcrumb([HOME_BC, ['Contact', '/contact']]),
    webPage('Contact VTCodex', '/contact', 'Get in touch with VTCodex.', 'ContactPage'),
  ],
};
